;(function (window) {
    console.log('Language translations loaded');

    const resources = {
        en: {
            translation: {
                checkoutTimeAlert: 'It is not possible to place an order to the selected time',
                checkoutClosedAlert: 'The store is closed, please try again later',
                storeIsClosed: 'The store is closed, please try again later',
                alertTOS: 'Please read and accept the terms of service',
                alertContactPerson: 'Please select a contact person',
                invalidPhoneNumber: 'Invalid phone number!',
                guestLoginCustomerNumberRequired: 'Guest customer number is required.',
                guestCheckoutNameRequired: 'Name is required for guest checkout.',
                guestCheckoutMobileRequired: 'Mobile number is required for guest checkout.',
                anErrorOccurred: 'An error occurred',
                modalCloseButton: 'Close',
                extraProductsWholeNumber: 'Additional products can only be ordered in whole quantities.',
                extraProductsInvalidProductID: 'Invalid productID',
                wrongCode: 'Wrong code!',
                somethingWentWrong: 'Something went wrong, please reload the page and try again',
                deleteCustomFont: 'Are you sure you want to delete this custom font? Standard fonts will be used instead.',
                deleteCustomFontConfirmation: 'Font was deleted!',
                saveCustomFont: 'Font was saved!',
                deleteCustomColor: 'Are you sure you want to delete your custom colors? Standard colors will be used instead.',
                deleteCustomColorConfirmation: 'Your colors were deleted!',
                saveCustomColor: 'Custom colors were saved!',
                closeStoreConfirmation: 'Are you sure you want to close the store? customer will not be able to add products to cart or place orders. You can open the store again at any time',
                closeStore: 'The store was closed!',
                closeStoreMessage: 'Customer cannot add products to the cart or place orders. OBS: The store must be opened manually.',
                openStoreConfirmation: 'Are you sure you want to open the store? customer will be able to add products to cart and place orders. You can close the store again at any time',
                openStore: 'The store was opened!',
                openStoreMessage: 'Customer can add products to the cart and place orders again.',
                saveMessage: 'Saved!',
                smsSettingsPartialSave: 'The SMS order confirmation setting was saved, but saving the other SMS settings could not be confirmed. Please try again.',
                errorTableMessage: 'You cannot have a table without columns',
                changeOrderSuccess: 'Order changed',
                changeOrderFail: 'Something went wrong, please reload the page and try again. If the problem persists, please contact our support department.',
                emptyShoppingCart: 'Do you want to empty the shopping cart and start over?',
                invalidNumber: 'Invalid number: ',
                invalidNumberMessage: 'check the number you entered. Only whole numbers are allowed',
                confirmChange: 'Changing this might affect the products in the cart. Are you sure you want to continue?',
                readMore: 'Read more...',
                savedTextMessage: 'The text was saved!',
                closeSale: 'Close sale',
                openSale: 'Open sale',
                chooseTimeDate: 'Please choose a date and time for when the store will be closed.',
                closeStoreToDateConfirm: 'Are you sure you want to close the store to ',
                closeStoreToInfo: '? Customer cannot add products to the cart or place orders. You can open the store again at any time.',
                saleClosedTo: 'The store was closed to ',
                noHits: 'No hits',
                extraCategoryFormProductsListButtonAdd: 'Add',
                extraCategoryFormProductsListButtonDelete: 'Delete',
                extraCategoryListSortPriority: 'Sorting priority is saved',
                extraCategoryListSortPriorityError: 'Sorting priority is not saved',
                extraCategoryGetError: 'Could not get extra category',
                extraCategoryCreateError: 'Could not create extra category',
                extraCategoryUpdateError: 'Could not update extra category',
                extraCategoryDeleteError: 'Could not delete extra category',
                extraCategoryProductsSearchError: 'Error occurred',
                extraCategoryDeleteConfirm: 'Do you want to delete extra category',
                extraCategorySearchError: 'Error occurred',
                departmentGetError: 'Could not get department',
                departmentCreateError: 'Could not create department',
                departmentUpdateError: 'Could not update department',
                departmentDeleteError: 'Could not delete department',
                departmentsSearchError: 'Error occurred',
                departmentDeleteConfirm: 'Do you want to delete department',
                shopDesignEditor: 'Shop Design Editor',
                addCategory: 'Add new product category',
                categoryNameLabel: 'Category name:',
                categoryNamePlaceholder: 'Enter category name...',
                categoryDescriptionLabel: 'Description (optional):',
                categoryDescriptionPlaceholder: 'Enter description...',
                cancel: 'Cancel',
                confirmAddCategory: 'Add category',
                categoryNameRequired: 'Please enter a category name.',
                addCategoryErrorPrefix: 'Error adding category: ',
                addCategoryFailed: 'Failed to add category',
                categoryAddedReload: 'Category added. Reloading page...',
                unknownError: 'Unknown error',
                toolbarClose: 'Close toolbar',
                toolbarOpen: 'Open toolbar',
                productCategoryTitle: 'Product category',
                addCategoryButton: 'Add new category',
                colorsTitle: 'Colors',
                colorBackground: 'Background',
                colorHeaderBackground: 'Header background',
                colorHeaderText: 'Header text',
                colorFooterBackground: 'Footer background',
                colorFooterText: 'Footer text',
                colorBasicButton: 'Order button background',
                colorBasicButtonText: 'Order button text',
                colorPlusButton: 'Plus button background',
                colorPlusButtonText: 'Plus button text',
                colorMenuButton: 'Category buttons and other buttons',
                colorMenuButtonText: 'Category button text and accessory buttons',
                colorMenuButtonHover: 'Category buttons and other buttons (hover)',
                colorMenuButtonTextHover: 'Category button text and accessory buttons (hover)',
                colorNewMenuBackground: 'Category background',
                colorNewMenuText: 'Category text',
                colorNewMenuScrollButtons: 'Side buttons',
                colorOldMenuArrows: 'Category arrows',
                colorShadow: 'Product shadow',
                colorCartBackground: 'Shopping cart',
                colorCartBorder: 'Shopping cart border',
                colorCartText: 'Shopping cart text',
                colorProductDescription: 'Product description',
                colorInfoBox: 'Category description background',
                colorInfoBoxText: 'Category description text',
                colorLinks: 'Links',
                colorGeneralText: 'General text',
                colorPanelHeaderBg: 'Top panel background',
                colorPanelHeaderText: 'Top panel text',
                colorPanelBodyBg: 'Bottom panel background',
                colorPanelBodyText: 'Bottom panel text',
                colorModalBg: 'Popup background',
                colorPickerLabel: 'Select color:',
                colorPickerLabelFor: 'Select color for:',
                saveColors: 'Save Colors',
                productLayoutTitle: 'Product Layout',
                layout1Label: 'Compact list (no images)',
                layout2Label: 'Cards with image right',
                layout3Label: 'Large images on top',
                layout4Label: 'Cards without image',
                productSettingsTitle: 'Product Settings',
                disableDefaultProductImage: 'Disable default image for products without image',
                useLogoAsDefaultProductImage: 'Use uploaded logo as default image when the product has no image',
                newCategoryMenuDesign: 'New category menu design (recommended)',
                shoppingCartPrevNextButtons: 'In cart: show previous and next menu buttons',
                hideCheckoutButtonFromTopMenu: 'Hide checkout button in top menu',
                hidePrices: 'Hide prices',
                allowProductInMultipleCategories: 'Allow a product to be in more than one category',
                takeProductStockIntoAccount: 'Consider stock; cannot order products that are out of stock',
                productMinimumQuantityInOrder: 'Enable minimum quantity per product in order (set in Fline under Admin > Products)',
                showPriceOnMobileShoppingCart: 'Show prices in mobile shopping cart',
                saveLayoutSettings: 'Save Layout Settings',
                logoFaviconTitle: 'Logo & Favicon',
                uploadLogo: 'Upload logo',
                uploadFavicon: 'Upload favicon',
                logoUploadTooLarge: 'Logo file is too large. Maximum size is 1MB.',
                logoUploadInvalidType: 'Invalid file type. Only PNG, JPG, JPEG and GIF are allowed.',
                uploading: 'Uploading...',
                logoUploadSuccess: 'Logo uploaded! Page will refresh automatically.',
                logoUploadErrorPrefix: 'Error uploading logo: ',
                logoUploadRetry: 'Error uploading logo. Please try again',
                faviconUploadTooLarge: 'Favicon file is too large. Maximum size is 100KB',
                faviconUploadInvalidType: 'Invalid file type. Only ICO and PNG are allowed for favicon',
                faviconUploadSuccess: 'Favicon uploaded! Page will refresh automatically.',
                faviconUploadErrorPrefix: 'Error uploading favicon: ',
                faviconUploadRetry: 'Error uploading favicon. Please try again',
                noLogoUploaded: 'No logo uploaded',
                noFaviconUploaded: 'No favicon uploaded',
                currentLogoAlt: 'Current logo',
                currentFaviconAlt: 'Current favicon',
                addProductButtonLabel: 'Add product',
                productSelectorTitle: 'Select product or product group',
                productSearchPlaceholder: 'Search for product...',
                addAllToggleLabel: 'Use product group (add all products from selected group)',
                loadingProductsOption: 'Loading products ...',
                confirmAddProduct: 'Add product',
                confirmAddGroup: 'Add all products in group',
                errorLoadingProducts: 'Error loading products',
                noProductsFound: 'No products found',
                unknownProduct: 'Unknown product',
                noProductGroupsFound: 'No product groups found',
                unknownProductGroup: 'Unknown product group',
                selectProductGroupFirst: 'Please select a product group first.',
                groupProductsFetchError: 'Error fetching products in the product group.',
                noProductsInGroup: 'No products found in this product group.',
                productsAddedFromGroup: 'All products in the product group have been added.',
                unexpectedGroupAddError: 'Unexpected error while adding products from the product group.',
                categoryNotDetermined: 'Could not determine category. Please select a category first.',
                saveProductToCategoryFailed: 'Failed to save product to category',
                productAlreadyInCategory: 'This product is already added to the category.',
                productHtmlFailed: 'Failed to get product HTML',
                productHtmlStructureNotFound: 'Product HTML structure not found',
                errorAddingProduct: 'Error adding product',
                productsWrapperNotFound: 'Products wrapper not found',
                dropHere: 'Drop here',
                removeProduct: 'Remove product',
                confirmRemoveProduct: 'Are you sure you want to remove this product from the category?',
                removeProductErrorPrefix: 'Error removing product: ',
                categoryOrderSaveFailed: 'Could not save category order',
                categoryOrderSaved: 'Category order saved',
                categoryOrderSaveError: 'Error saving category order',
                colorsSavedReload: 'Colors saved. Reloading page...',
                colorsSaveErrorPrefix: 'Error saving colors: ',
                fontPickerNotFound: 'Font picker not found',
                fontSavedReload: 'Font saved. Reloading page...',
                fontSaveErrorPrefix: 'Error saving font: ',
                fontSaveError: 'Error saving font',
                layoutSettingsSavedReload: 'Layout settings saved. Reloading page...',
                layoutSettingsSaveErrorPrefix: 'Error saving settings: ',
                layoutSettingsSaveError: 'Error saving settings',
                productLayoutSavedReload: 'Product layout saved. Reloading page...',
                productLayoutSaveErrorPrefix: 'Error saving layout: ',
                productLayoutSaveError: 'Error saving layout',
                networkError: 'Network error',
                designResetConfirm: 'Are you sure you want to reset the design to default?',
                designResetMessage: 'Design reset to default'
            }

        },
        no: {
            translation: {
                checkoutTimeAlert: 'Det er dessverre ikke mulig å bestille til valgt tidspunkt',
                checkoutClosedAlert: 'Vi tar dessverre ikke imot bestillinger akkurat nå fordi vi har stengt, men du er velkommen tilbake senere',
                storeIsClosed: 'Serveringsstedet er stengt',
                alertTOS: 'Du må lese og akseptere kjøpsvilkårene',
                alertContactPerson: 'Du må velge en kontaktperson',
                invalidPhoneNumber: 'Ugyldig mobilnummer!',
                guestLoginCustomerNumberRequired: 'Kundenummer for gjestekunde er påkrevd.',
                guestCheckoutNameRequired: 'Navn er påkrevd for gjestebestilling.',
                guestCheckoutMobileRequired: 'Mobilnummer er påkrevd for gjestebestilling.',
                anErrorOccurred: 'Det oppsto en feil',
                modalCloseButton: 'Lukk',
                extraProductsWholeNumber: 'Ekstraprodukter kan kun bestilles i hel antall',
                extraProductsInvalidProductID: 'Ugyldig produktID',
                wrongCode: 'Feil kode!',
                somethingWentWrong: 'Noe gikk feil. Last siden på nytt og prøv igjen',
                deleteCustomFont: 'Er du sikker på at du vil slette egendefinert skrifttype? Standard skrifttype vil gjelde for nettsiden.',
                deleteCustomFontConfirmation : 'Skrifttype ble slettet!',
                saveCustomFont: 'Skrifttype ble lagret!',
                deleteCustomColor: 'Er du sikker på at du vil slette dine egendefinerte farger? Standard farger vil gjelde for nettsiden.',
                deleteCustomColorConfirmation: 'dine farger ble slettet!',
                saveCustomColor: 'Egendefinerte farger ble lagret!',
                closeStoreConfirmation: 'Er du sikker på at du vil stenge nettbutikken? Kunder kan ikke legge varer i handlekurven eller legge inn nye bestillinger. Du kan når som helst åpne igjen.',
                closeStore: 'Salget ble stengt!',
                closeStoreMessage: 'Kunder i nettbutikken får IKKE lov til å legge varer i handlekurven eller legge inn nye bestillinger. OBS: Må åpnes manuelt.',
                openStoreConfirmation: 'Er du sikker på at du vil åpne nettbutikken? Kunder vil da kunne legge varer i handlekurven og legge inn nye bestillinger. Du kan når som helst stenge igjen.',
                openStore: 'Salget ble åpnet!',
                openStoreMessage: 'Kunder i nettbutikken kan nå legge varer i handlekurv og legge inn nye bestillinger igjen.',
                saveMessage: 'Lagret!',
                smsSettingsPartialSave: 'Valget for ordrebekreftelse på SMS er lagret, men lagringen av de øvrige SMS-innstillingene kunne ikke bekreftes. Prøv igjen.',
                errorTableMessage: 'Du kan ikke ha en tabell uten kolonner',
                changeOrderSuccess: 'Rekkefølge endret',
                changeOrderFail: 'Kunne dessverre ikke endre rekkefølgen. Prøv å last siden på nytt og prøv igjen. Hvis problemet vedvarer, vennligst ta kontakt med vår supportavdeling.',
                emptyShoppingCart: 'Vil du tømme handlekruv og starte på nytt?',
                invalidNumber: 'Ugyldig antall: ',
                invalidNumberMessage: 'Kontroller antallet som er skrevet inn. Kun heltall er lov',
                confirmChange: 'Dersom du endrer denne nå, kan det påvirke varene du har lagt i handlekurven',
                readMore: 'Vis mer...',
                savedTextMessage: 'Teksten ble lagret!',
                closeSale: 'Steng salg',
                openSale: 'Åpne salg',
                chooseTimeDate: 'Vennligst velg dato og klokkeslett for når netbutikken skal stenges.',
                closeStoreToDateConfirm: 'Er du sikker på at du vil stenge nettbutikken til ',
                closeStoreToInfo: '? Kunder kan ikke legge varer i handlekurven eller legge inn nye bestillinger. Du kan når som helst åpne igjen.',
                saleClosedTo: 'Salget ble stengt til ',
                noHits: 'Ingen treff',
                extraCategoryFormProductsListButtonAdd: 'Legg til',
                extraCategoryFormProductsListButtonDelete: 'Slett',
                extraCategoryListSortPriority: 'Sorteringsprioritet er lagret',
                extraCategoryListSortPriorityError: 'Sorteringsprioritet er ikke lagret',
                extraCategoryGetError: 'Kunne ikke hente ekstra kategori',
                extraCategoryCreateError: 'Kunne ikke opprette ekstra kategori',
                extraCategoryUpdateError: 'Kunne ikke oppdatere ekstra kategori',
                extraCategoryDeleteError: 'Kunne ikke slette ekstra kategori',
                extraCategoryProductsSearchError: 'Feil oppsto',
                extraCategoryDeleteConfirm: 'Vil du slette ekstra kategori',
                extraCategorySearchError: 'Feil oppsto',
                departmentGetError: 'Kunne ikke hente avdeling',
                departmentCreateError: 'Kunne ikke opprette avdeling',
                departmentUpdateError: 'Kunne ikke oppdatere avdeling',
                departmentDeleteError: 'Kunne ikke slette avdeling',
                departmentsSearchError: 'Feil oppsto',
                departmentDeleteConfirm: 'Vil du slette avdeling',
                shopDesignEditor: 'Redigerings verktøy',
                addCategory: 'Legg til ny produkt kategori',
                categoryNameLabel: 'Kategorinavn:',
                categoryNamePlaceholder: 'Skriv inn kategorinavn...',
                categoryDescriptionLabel: 'Beskrivelse (valgfritt):',
                categoryDescriptionPlaceholder: 'Skriv inn beskrivelse...',
                cancel: 'Avbryt',
                confirmAddCategory: 'Legg til kategori',
                categoryNameRequired: 'Vennligst skriv inn et kategorinavn.',
                addCategoryErrorPrefix: 'Feil ved å legge til kategori: ',
                addCategoryFailed: 'Kunne ikke legge til kategori',
                categoryAddedReload: 'Kategori lagt til. Laster siden på nytt...',
                unknownError: 'Ukjent feil',
                toolbarClose: 'Lukk toolbar',
                toolbarOpen: 'Åpne toolbar',
                productCategoryTitle: 'Produktkategori',
                addCategoryButton: 'Legg til ny kategori',
                colorsTitle: 'Farger',
                colorBackground: 'Bakgrunn',
                colorHeaderBackground: 'Bakgrunn header',
                colorHeaderText: 'Tekst header',
                colorFooterBackground: 'Bakgrunn footer',
                colorFooterText: 'Tekst footer',
                colorBasicButton: 'Bakgrunn bestillingsknapp',
                colorBasicButtonText: 'Tekst bestillingsknapp',
                colorPlusButton: 'Bakgrunn plussknapp',
                colorPlusButtonText: 'Tekst plussknapp',
                colorMenuButton: 'Farge på kategoriknapper og andre knapper',
                colorMenuButtonText: 'Farge på tekst i kategoriknapper og andre knapper (tilbehør)',
                colorMenuButtonHover: 'Farge på kategoriknapper og andre knapper (tilbehør) når man holder musen over',
                colorMenuButtonTextHover: 'Farge på tekst i kategoriknapper og andre andre knapper (tilbehør) når man holder musepekeren over',
                colorNewMenuBackground: 'Bakgrunn kategori',
                colorNewMenuText: 'Tekst kategori',
                colorNewMenuScrollButtons: 'Sideknapper',
                colorOldMenuArrows: 'Piler kategori',
                colorShadow: 'Skygge på produkter',
                colorCartBackground: 'Handlekurv',
                colorCartBorder: 'Handlekurv kant',
                colorCartText: 'Handlekurv tekst',
                colorProductDescription: 'Produktbeskrivelse',
                colorInfoBox: 'Bakgrunn kategoribeskrivelse',
                colorInfoBoxText: 'Tekst kategoribeskrivelse',
                colorLinks: 'Lenker',
                colorGeneralText: 'Tekst generell',
                colorPanelHeaderBg: 'Bakgrunn topppaneler',
                colorPanelHeaderText: 'Tekst topppaneler',
                colorPanelBodyBg: 'Bakgrunn bunnpanel',
                colorPanelBodyText: 'Tekst bunnpanel',
                colorModalBg: 'Bakgrunn popups',
                colorPickerLabel: 'Velg farge:',
                colorPickerLabelFor: 'Velg farge for:',
                saveColors: 'Lagre farger',
                productLayoutTitle: 'Produktlayout',
                layout1Label: 'Tett liste (uten bilder)',
                layout2Label: 'Kort med bilde høyre',
                layout3Label: 'Store bilder øverst',
                layout4Label: 'Kort uten bilde',
                productSettingsTitle: 'Produktinnstillinger',
                disableDefaultProductImage: 'Deaktiver standard bilde på varer uten bilde',
                useLogoAsDefaultProductImage: 'Bruk opplastet logo som standard varebilde der varen ikke har egent bilde',
                newCategoryMenuDesign: 'Nytt design på kategorimeny (anbefales)',
                shoppingCartPrevNextButtons: 'I handlekurv: vis knapper for forrige og neste menypunkt',
                hideCheckoutButtonFromTopMenu: 'Skjul handleknapp i toppmeny',
                hidePrices: 'Skjul priser',
                allowProductInMultipleCategories: 'Tillat at et produkt legges i mer enn en kategori',
                takeProductStockIntoAccount: 'Ta hensyn til lagerbeholdning. Kan ikke handle varer som er tomme på lager i Frontline',
                productMinimumQuantityInOrder: 'Aktiver minimum antall per vare ved bestilling (settes i Fline under Admin > Produkter)',
                showPriceOnMobileShoppingCart: 'Vis priser i mobiltelefon handlekurv',
                saveLayoutSettings: 'Lagre layout-innstillinger',
                logoFaviconTitle: 'Logo & Favicon',
                uploadLogo: 'Last opp logo',
                uploadFavicon: 'Last opp favicon',
                logoUploadTooLarge: 'Logo filen er for stor. Maximum størrelse er 1MB.',
                logoUploadInvalidType: 'Ugyldig filtype. Kun PNG, JPG, JPEG og GIF er tillatt.',
                uploading: 'Laster opp...',
                logoUploadSuccess: 'Logo opplastet! Siden vil oppdatere seg automatisk.',
                logoUploadErrorPrefix: 'Feil ved opplasting av logo: ',
                logoUploadRetry: 'Feil ved opplasting av logo. Prøv igjen',
                faviconUploadTooLarge: 'Favicon filen er for stor. Maksimum størrelse er 100KB',
                faviconUploadInvalidType: 'Ugyldig filtype. Kun ICO og PNG er tillatt for favicon',
                faviconUploadSuccess: 'Favicon opplastet! Siden vil oppdatere seg automatisk.',
                faviconUploadErrorPrefix: 'Feil ved opplasting av favicon: ',
                faviconUploadRetry: 'Feil ved opplasting av favicon. Prøv igjen',
                noLogoUploaded: 'Ingen logo lastet opp',
                noFaviconUploaded: 'Ingen favicon lastet opp',
                currentLogoAlt: 'Nåværende logo',
                currentFaviconAlt: 'Nåværende favicon',
                addProductButtonLabel: 'Legg til produkt',
                productSelectorTitle: 'Velg produkt eller varegruppe',
                productSearchPlaceholder: 'Søk etter produkt...',
                addAllToggleLabel: 'Bruk varegruppe (legg til alle varer fra valgt varegruppe)',
                loadingProductsOption: 'Laster produkter ...',
                confirmAddProduct: 'Legg til produkt',
                confirmAddGroup: 'Legg til alle varer i varegruppe',
                errorLoadingProducts: 'Feil ved lasting av produkter',
                noProductsFound: 'Ingen produkter funnet',
                unknownProduct: 'Ukjent produkt',
                noProductGroupsFound: 'Ingen varegrupper funnet',
                unknownProductGroup: 'Ukjent varegruppe',
                selectProductGroupFirst: 'Vennligst velg en varegruppe først.',
                groupProductsFetchError: 'Feil ved henting av produkter i varegruppen.',
                noProductsInGroup: 'Ingen produkter funnet i denne varegruppen.',
                productsAddedFromGroup: 'Alle produkter i varegruppen er lagt til.',
                unexpectedGroupAddError: 'Uventet feil ved tillegg av produkter i varegruppen.',
                categoryNotDetermined: 'Kunne ikke bestemme kategori. Vennligst velg en kategori først.',
                saveProductToCategoryFailed: 'Kunne ikke lagre produkt til kategori',
                productAlreadyInCategory: 'Dette produktet er allerede lagt til i kategorien.',
                productHtmlFailed: 'Kunne ikke hente produkt-HTML',
                productHtmlStructureNotFound: 'Produkt-HTML-struktur ikke funnet',
                errorAddingProduct: 'Feil ved å legge til produkt',
                productsWrapperNotFound: 'Products wrapper ikke funnet',
                dropHere: 'Slipp her',
                removeProduct: 'Fjern produkt',
                confirmRemoveProduct: 'Er du sikker på at du vil fjerne dette produktet fra kategorien?',
                removeProductErrorPrefix: 'Feil ved fjerning av produkt: ',
                categoryOrderSaveFailed: 'Kunne ikke lagre kategori-rekkefølge',
                categoryOrderSaved: 'Kategori-rekkefølge lagret',
                categoryOrderSaveError: 'Feil ved lagring av kategori-rekkefølge',
                colorsSavedReload: 'Farger lagret. Laster siden på nytt...',
                colorsSaveErrorPrefix: 'Feil ved lagring av farger: ',
                fontPickerNotFound: 'Font picker ikke funnet',
                fontSavedReload: 'Font lagret. Laster siden på nytt...',
                fontSaveErrorPrefix: 'Feil ved lagring av font: ',
                fontSaveError: 'Feil ved lagring av font',
                layoutSettingsSavedReload: 'Layout innstillinger lagret. Laster siden på nytt...',
                layoutSettingsSaveErrorPrefix: 'Feil ved lagring av innstillinger: ',
                layoutSettingsSaveError: 'Feil ved lagring av innstillinger',
                productLayoutSavedReload: 'Product layout lagret. Laster siden på nytt...',
                productLayoutSaveErrorPrefix: 'Feil ved lagring av layout: ',
                productLayoutSaveError: 'Feil ved lagring av layout',
                networkError: 'Nettverksfeil',
                designResetConfirm: 'Er du sikker på at du vil resette designet til standard?',
                designResetMessage: 'Design satt tilbake til standard'
            }
        }
    };

    function initI18n(defaultLang) {
        defaultLang = defaultLang || 'no';
        return new Promise(function(resolve, reject){
            i18next.init({
                resources: resources,
                lng: defaultLang,
                fallbackLng: 'en',
                interpolation: { escapeValue: false }
            }, function(err, t){
                if (err) return reject(err);
                resolve();
            });
        });
    }

    function changeLanguageJS(newLang) {
        return new Promise(function(resolve, reject){
            i18next.changeLanguage(newLang, function(err, t){
                if (err) return reject(err);
                resolve();
            });
        });
    }

    function t(key) {
        return i18next.t(key);
    }

    window.initI18n = initI18n;
    window.changeLanguageJS = changeLanguageJS;
    window.t = t;
})(window);
